import React, { Component } from "react";
import axios from "axios";
import ConteudoResumo from "./ConteudoResumo";
import Controlos from "../../components/Controlos";
import { GlobalContext } from "../../../../app/providers/GlobalState";
import LazyLoad from "react-lazy-load";

class Resumo extends Component {
    static contextType = GlobalContext;

    render() {
        return (
            <div className="questionario-resumo">
                <div className="player-wrapper">
                    <ConteudoResumo />
                    <Controlos
                        backUrl={`/gerir-detalhe-turma/${this.props.match.params.curso
                            .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                            .toLowerCase()}/modulos`}
                        sameUrl={true}
                        temAnotacoes
                    />
                </div>
            </div>
        );
    }
}

export default Resumo;
